import { ColumnDef } from "@tanstack/react-table";
import { DetailedUserWithStats } from "@/user/user.d";

export const ClosedReferralsCol = (): ColumnDef<DetailedUserWithStats> => ({
  header: "Closed Referrals",
  accessorFn: (row) => row.stats?.closed_referral_count ?? 0,
});
